import React, { Fragment } from "react";
import { GenErrorPageWithButton } from "../components/GenErrorPageWithButton";
import { Routes } from "../constants/Routing";

export interface SwitchToSafariProps {
  uuid?: string;
  appId?: string;
  docType?: string;
}

export const SwitchToSafari: React.SFC<SwitchToSafariProps> = (props: SwitchToSafariProps) => {

  const onUploadManuallyClick = () => {
    Routes.goToUploadManual(props.uuid, props.appId, props.docType);
  };

  const description = (
    <Fragment>
      It appears that you are using a browser that does not allow access to your device's camera for instant
      verification. Please use your Safari Browser App instead to access this page, or proceed to upload your
      documents manually instead.
    </Fragment>
  );

  return (
    <GenErrorPageWithButton
      title="Please Use Safari"
      description={description}
      buttonTitle={"Upload Manually"}
      onButtonPress={onUploadManuallyClick}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/SwitchToSafari.tsx